import axios from 'axios'

const url = {
  esIndexReset: '/api/maintenance/esindex/reset',
  dbBackup: '/api/maintenance/db/backup'
}

export default {
  async esIndexReset () {
    return await axios.post(url.esIndexReset)
  },
  async dbBackup () {
    return await axios.post(url.dbBackup)
  }
}
